import { isAtLeastBreakpoint } from '@/theme/breakpoints';
import { isHeadlessBrowser } from '@/utils/isHeadlessBrowser';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import * as React from 'react';
gsap.registerPlugin(ScrollTrigger);
function useSplitParallax() {
    const containerRef = React.useRef(null);
    useGSAP(() => {
        if (isHeadlessBrowser() === true) {
            return;
        }
        const isAtLeastSm = isAtLeastBreakpoint('sm');
        const mm = gsap.matchMedia();
        mm.add('(prefers-reduced-motion: no-preference)', () => {
            const timeline = gsap.timeline({
                scrollTrigger: {
                    scrub: isAtLeastSm ? true : 0.5,
                    trigger: containerRef.current,
                    start: 'top 70%',
                    end: isAtLeastSm ? 'bottom 50%' : 'bottom 100%',
                    markers: process.env.NODE_ENV === 'development',
                },
            });
            timeline.fromTo('[data-split-parallax-img]', {
                translateY: (index) => {
                    switch (index) {
                        case 0:
                            return '50%';
                        case 1:
                            return isAtLeastSm ? '150%' : '60%';
                        default:
                            return '175%';
                    }
                },
                filter: (index) => {
                    switch (index) {
                        case 0:
                            return 'blur(0px)';
                        default:
                            return 'blur(3px)';
                    }
                },
                opacity: (index) => {
                    switch (index) {
                        case 0:
                            return 1;
                        case 1:
                            return 0.6;
                        default:
                            return 0.4;
                    }
                },
            }, {
                duration: 2,
                translateY: '0%',
                filter: 'blur(0px)',
                ease: 'power2.out',
                opacity: 1,
            });
        });
        return () => mm.revert();
    }, { scope: containerRef, dependencies: [isHeadlessBrowser] });
    return containerRef;
}
export default useSplitParallax;
